import $ from 'jquery';
import { closeModal } from '@/function/function.js';

export default {
    name: 'liste-patient',
    components: {},
    props: [],
    data() {
        return {
            fields: [{ key: 'index', label: 'N°' }, { key: 'code', label: 'Numéro de dossier' }, 'nom', 'prenoms', 'sexe', 'telephone_mobile', 'actions'],
            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,
            selectedPatient: null,
            posts: [{

                    userId: 1,
                    id: 1,
                    title: "sunt aut facere repellat provident occaecati",
                },
                {
                    userId: 1,
                    id: 2,
                    title: "qui est esse",
                },
                {
                    userId: 1,
                    id: 3,
                    title: "ea molestias quasi exercitationem repellat qui",
                },
            ],
        }
    },
    mounted() {
        // si utilistateur est de type sage femme, lui afficher sa liste
        if (this.user_role == 'ROLE_SAGE_FEMME') {
            this.$store.dispatch('getPatientsTypeCons', "CPN").then(() => {
                this.tableIsBusy = false;
            });
        } else {
            this.$store.dispatch('getPatients').then(() => {
                this.tableIsBusy = false;
            });
        }


        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);
    },
    computed: {
        patients() {
            return this.$store.getters['patients']
        },
        rows() {
            return this.patients.length;
        },
        isBusy() {
            if (this.patients === null) {
                return true
            } else {
                return false;
            }
        },
        user_role() {
            return this.$store.getters['activeRole'].nom;
        },

    },
    methods: {

        getPatients: function() {

        },
        modalDeletePatient: function(patient) {
            this.selectedPatient = patient
        },
        deletePatient: function(id) {

            this.$store.dispatch("deletePatient", id).then(() => {
                this.$refs.closeBtn.click();
                this.deletionSuccess()
            })
        },

        close: function() {
            $('#exampleModal').modal('show')
        },
        deletionSuccess: function() {
            this.$toasted.show('Le compte du patient a été supprimé avec succès', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success'
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        }
    }
}